module.exports = __webpack_public_path__ + "win-0e7ee51adccda6b0e616.gif";